import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

export function usePurifyTranslation() {
  const { t, ...rest } = useTranslation();

  return {
    purifyT: (key, options) => DOMPurify.sanitize(t(key, options)),
    ...rest
  };
}
